<template>
  <div>
    <AlertDismiss ref="alert"/>
    <form @submit.prevent="onSubmit">
      <label for="nameInput">Nombre del curso</label>
      <input
        v-model="form.name"
        type="text"
        id="nameInput"
        class="form-control mb-2"
        required
      />

      <label for="roleSelect">Rol</label>
      <b-overlay :show="fetchingRoles" class="overlay">
        <select
          v-model="form.roleIds"
          id="roleSelect"
          class="form-control mb-2"
          multiple
          :size="numRoles"
          required
          ref="roleSelect"
        >
          <option v-for="role in roles" :key="role.id" :value="role.id">{{role.name}}</option>
        </select>      
      </b-overlay>

      <button type="submit" class="btn btn-primary" :disabled="isUploading">
        <b-spinner v-if="isUploading" small class="me-2"/>
        Crear 
      </button>
    </form>
  </div>
</template>

<script>
import {mapActions} from 'vuex';
import AlertDismiss from '@/components/shared/Alert-dismiss.vue'
import {EventNames} from '@/plugins/enums/index.js'

export default {
  name: 'CourseForm',

  data() {
    return {
      form: {
        name: null,
        roleIds: []
      },
      roles: [],

      isUploading: false
    }
  },

  computed: {
    numRoles() {
      return this.roles.length
    },

    fetchingRoles() {
      return this.roles.length === 0
    }
  },

  components: {
    AlertDismiss
  },

  async mounted() {
    this.isUploading = true
    await this.getRoles()
    this.isUploading = false
  },

  methods: {
    ...mapActions(["saveCourse", "allRoles"]),

    async onSubmit() {
      this.isUploading = true
      let result = await this.saveCourse(this.form)
      if (result.isError) {
        this.$refs.alert.showAlert(result.message, 'warning')
        this.isUploading = false
        return
      }
      
      this.$refs.alert.showAlert('Curso creado correctamente', 'success')
      this.$eventBus.$emit(EventNames.CreatedCourse)
      this.isUploading = false
      this.form.name = null
      this.$set(this.form, 'roleIds', [])
      this.$refs.roleSelect.value = []
    },

    async getRoles() {
      let result = await this.allRoles()
      if (result.isError) {
        this.$refs.alert.showAlert(result.message, 'warning')
        return
      }

      this.roles = result.data
    },
  }
}

</script>

<style scoped>
.overlay {
  min-height: 80px;
}
</style>